type TResult = string | number | `${number}-${number}`;

interface IParams {
  min?: number | string;
  max?: number | string;
}

const defaultParam: IParams = { min: '', max: '' };

export const getDeliveryInterval = ({ min = '', max = '' } = defaultParam): TResult => {
  // 1, 2, 3 дня только минимум, все что больше 3-5 дней с мин и макс
  if (min && max) {
    return min === max ? max : `${min}-${max}`;
  }

  return min || max;
};
